const initialState = {
  newLocationFlag: false,
  location: null,
  buildingId: '',
  typeId: '',
};

export default initialState;
